import { NavLink, useLocation } from "react-router-dom";
import { Home, CalendarPlus, ShoppingBag, User } from "lucide-react";
import { useEffect, useState } from "react";
import { isStandalone } from "@/lib/pwa";

const HIDDEN = ["/admin", "/pdv", "/colaborador", "/auth", "/admin-setup", "/reset-password", "/ficha"];

/** Native-style bottom tabs for the installed customer app (standalone only). */
export const ClientTabBar = () => {
  const { pathname, hash } = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => { setShow(isStandalone()); }, []);
  if (!show || HIDDEN.some((h) => pathname.startsWith(h))) return null;

  const tab = "flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-[11px] font-medium transition-colors";
  const on = "text-primary", off = "text-muted-foreground";
  return (
    <nav aria-label="Navegação principal" className="fixed bottom-0 inset-x-0 z-50 border-t border-border bg-card/95 backdrop-blur pb-[env(safe-area-inset-bottom)] flex">
      <NavLink to="/" end className={() => `${tab} ${pathname === "/" && hash !== "#agendar" ? on : off}`}><Home size={22} />Início</NavLink>
      <NavLink to="/#agendar" className={() => `${tab} ${pathname === "/" && hash === "#agendar" ? on : off}`}><CalendarPlus size={22} />Reservar</NavLink>
      <NavLink to="/loja" className={({ isActive }) => `${tab} ${isActive ? on : off}`}><ShoppingBag size={22} />Loja</NavLink>
      <NavLink to="/minha-conta" className={({ isActive }) => `${tab} ${isActive ? on : off}`}><User size={22} />Conta</NavLink>
    </nav>
  );
};
